export const sidebarTranslations = {
    // Current translations
    home: {
        Svenska: "Hem",
        Engelska: "Home",
    },
    myContents: {
        Svenska: "Mitt innehåll",
        Engelska: "My content",
    },
    // Additional translations needed
    chat: {
        Svenska: "Chat",
        Engelska: "Chat",
    },
    upgradeAccount: {
        Svenska: "Uppgradera konto",
        Engelska: "Upgrade account",
    },
    myLessons: {
        Svenska: "Mina lektioner",
        Engelska: "My lessons",
    },
    myQuizzes: {
        Svenska: "Mina quiz",
        Engelska: "My quizzes",
    },
    myFlashcards: {
        Svenska: "Mina flashcards",
        Engelska: "My flashcards",
    },
    myFiles: {
        Svenska: "Mina filer",
        Engelska: "My files",
    },
    lessons: {
        Svenska: "Lektioner",
        Engelska: "Lessons",
    },
    generateLesson: {
        Svenska: "Generera lektion",
        Engelska: "Generate lesson",
    },
    assessment: {
        Svenska: "Bedömning",
        Engelska: "Assessment",
    },
    newAssessment: {
        Svenska: "Ny bedömning",
        Engelska: "New assessment",
    },
    myAssessments: {
        Svenska: "Mina bedömningar",
        Engelska: "My assessments",
    },
    classes: {
        Svenska: "Klasser",
        Engelska: "Classes",
    },
    createNewClass: {
        Svenska: "Skapa ny klass",
        Engelska: "Create new class",
    },
    myClasses: {
        Svenska: "Mina klasser",
        Engelska: "My classes",
    },
    assessmentMatrices: {
        Svenska: "Bedömningsmatriser",
        Engelska: "Assessment matrices",
    },
    createNewMatrix: {
        Svenska: "Skapa ny matris",
        Engelska: "Create new matrix",
    },
    myMatrices: {
        Svenska: "Mina matriser",
        Engelska: "My matrices",
    },
    quizzes: {
        Svenska: "Quiz",
        Engelska: "Quizzes",
    },
    generateQuiz: {
        Svenska: "Generera quiz",
        Engelska: "Generate quiz",
    },
    quizBank: {
        Svenska: "Quiz-banken",
        Engelska: "Quiz bank",
    },
    flashcards: {
        Svenska: "Flashcards",
        Engelska: "Flashcards",
    },
    generateFlashcards: {
        Svenska: "Generera flashcards",
        Engelska: "Generate flashcards",
    },
    flashcardsBank: {
        Svenska: "Flashcards-banken",
        Engelska: "Flashcards bank",
    },
    images: {
        Svenska: "Bilder",
        Engelska: "Images",
    },
    generateImages: {
        Svenska: "Generera bilder",
        Engelska: "Generate images",
    },
    imageAnalysis: {
        Svenska: "Bildanalys",
        Engelska: "Image analysis",
    },
    imageBank: {
        Svenska: "Bildbanken",
        Engelska: "Image bank",
    },
    assistants: {
        Svenska: "Assistenter",
        Engelska: "Assistants",
    },
    upgrade: {
        Svenska: "Uppgradera",
        Engelska: "Upgrade",
    },
    admin: {
        Svenska: "Admin",
        Engelska: "Admin",
    },
    lessonBank: {
        Svenska: "Lektionsbanken",
        Engelska: "Lesson bank",
    },
    giveFeedback: {
        Svenska: "Ge feedback",
        Engelska: "Give feedback",
    },
};
